<template>
    <div class="__em-attachment-list">
        <p class="__em-attachment-list-title mt-color-grey-lv3" v-if="caption">{{caption}}</p>
        <mt-cell v-for="(file,index) in attachments" :to="getPreviewUrl(file)" @click.native="handleClick(file)"  :value-align="textalign" v>
            <i class="iconfont" :class="getTypeIcon(file)" slot="icon" v-if="!_isImage(file)"></i>
            <img :src="file.fileUrl" class="__em-img-icon" slot="icon" v-if="_isImage(file)"></img>
            <div slot="title" class="__em-file-info">
                <p class="__em-file-info_name">{{param.fileName?(param.fileName + (index + 1)):file.name}}</p>
                <p class="__em-file-info_size">{{getFileSize(file)}}</p>
            </div>
        </mt-cell>
        <p v-if="!attachments || !attachments.length" class="__em-attachment-list-title mt-color-grey-lv3">暂无数据</p>
    </div>
</template>
<script>
import { Utils } from '../formUtils';
export default {

    name: 'emAttachmentList',

    props: {
        model: {
            type: Object,
            default: function() {
                return {};
            }
        },
        value: null,
        titlewidth:{
            type: String,
            default: function() {
                return '';
            }
        },
        textalign:{
            type: String,
            default: function() {
                return '';//flex-start
            }
        }
    },

    data() {
        return {
            attachments: [/*{
                name: 'xxx.jpg',
                size: '11',
                fileUrl: 'emapm.do'
            }*/],
            hostNmae: location.origin + location.pathname.substring(0, location.pathname.indexOf("/", 1)),
            fileIconEnum: [{
                type: ['xls', 'xlsx'],
                icon: 'icon-xlsx color-xlsx'
            }, {
                type: ['pdf'],
                icon: 'icon-pdf color-pdf'
            }, {
                type: ['zip'],
                icon: 'icon-zip'
            }, {
                type: ['doc', 'docx'],
                icon: 'icon-doc color-doc'
            }, {
                type: ['ppt', 'pptx'],
                icon: 'icon-ppt color-ppt'
            }]
        };
    },

    computed: {
        param() {
            return this.model.initParam;
        },
        caption() {
            if (this.model.caption) {
                return this.model.caption;
            }
            return '';
        }
    },

    watch: {
        value() {
            this.queryAttachments();
        }
    },

    created() {
        this.queryAttachments();
    },

    methods: {
        queryAttachments() {
            if (this.value) {
                Utils.Post(this.hostNmae + '/sys/emapcomponent/file/getUploadedAttachment.do', {
                    fileToken: this.value
                }).then(({ data }) => {
                    if (data.success) {
                        this.attachments = data.items;
                    }
                });
            }else {
                this.attachments = [];
            }
        },
        getFileSize(file) {
            var fileSize = (file.size / (1000 * 1000)).toFixed(1);
            if (fileSize >= 1) {
                return fileSize + 'MB';
            } else {
                return (file.size / 1000).toFixed(0) + 'KB';
            }
        },
        getTypeIcon(file) {
            let type = this._getFiltType(file);
            let i = this.fileIconEnum.length - 1;
            while (i >= 0) {
                let iconMap = this.fileIconEnum[i];
                if (iconMap.type.indexOf(type) > -1) {
                    return iconMap.icon;
                }
                i--;
            }
            return 'icon-others color-others';
        },
        _getFiltType(file) {
            let match = file.name.toLowerCase().match(/.+\.(.+)?/);
            if (match) {
                return match[1];
            }
            return file.name;
        },
        _isImage(file) {
            let type = this._getFiltType(file);
            return /jpg$|jpeg$|png$|gif$|bmp$/.test(type);
        },
        handleClick(file) {
            if (this._isImage(file)) {
                let isWeiXin = () => /micromessenger/.test(navigator.userAgent.toLowerCase());
                let isDingTalk = () => /dingtalk/.test(navigator.userAgent.toLowerCase());
                let isDaliyCampus = () => /wisedu/.test(navigator.userAgent.toLowerCase());
                if (isWeiXin() || isDingTalk() || isDaliyCampus()) {
                    let imgs = [];
                    let index = 0;
                    this.attachments.forEach((item) => {
                        if (this._isImage(item)) {
                            if (item.fileUrl === file.fileUrl) {
                                index = imgs.length;
                            }
                            imgs.push({
                                url:location.origin + item.fileUrl
                            });
                        }
                    });
                    //某些第三方的app环境下utils.getJsSDK().preViewImages()和 BH_MIXIN_SDK 都不能用。
                    //只能用SDK，所以应用在初始化SDK的时候将SDK挂载在window下是必须的
                    if(Utils.getJsSDK().preViewImages){
                        Utils.getJsSDK().preViewImages(imgs, index);
                    } else if(SDK){
                        SDK.preViewImages(imgs,index);
                    }
                }else {
                    window.open(location.origin + file.fileUrl,"_blank");
                }
            }
        },
        getPreviewUrl(file) {
            if (this._isImage(file)) {
                return null;
            }
            let type = this._getFiltType(file);
            if (type === 'pdf') {
                return this.hostNmae + '/sys/emapcomponent/pdf/index.do?file=' + encodeURIComponent(file.fileUrl);
            }
            return location.origin + file.fileUrl;
        }
    }
};
</script>
<style lang="css" scoped>
.__em-attachment-list {
    padding-left: 1px;
}
.__em-attachment-list .iconfont {
    font-size: 32px;
    vertical-align: middle;
    margin-right: 8px;
}
.__em-attachment-list-title {
    padding:8px 0;
    /* font-size:14px; */
}
.__em-attachment-list .file-info {
    flex: 1;
}

.__em-attachment-list .color-pdf {
    color: #F26666;
}

.__em-attachment-list .color-doc {
    color: #4A90E2;
}

.__em-attachment-list .color-xlsx {
    color: #A2D06B;
}

.__em-attachment-list .color-ppt {
    color: #F26666;
}

.__em-attachment-list .color-zip {
    color: #92969C;
}

.__em-attachment-list .color-others {
    color: #FFB950;
}

.__em-file-info_size {
    margin-top: 4px;
    font-size: 14px;
    color: #92969C;
}

.__em-file-info {
    width: calc(100% - 40px)
}

.__em-file-info>p {
    margin: 0;
    padding: 1px 0 0 0;
}

.__em-file-info .__em-file-info_name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-bottom: 4px;
}

.__em-img-icon {
    height: 32px;
    width:30px;
    margin-right: 8px;
}
/* 只读表单下的设置 */
.emapm-form.emapm-form-readonly .__em-attachment-list {
    /* border-top-width: 1px;
    border-top-style: solid;
    padding: 8px 0 8px 1px;
    border-color: #E8E8E8; */
}
.emapm-form.emapm-form-readonly .__em-attachment-list-title {
    padding:6px 0;
    font-size:14px;
}
.emapm-form.emapm-form-readonly .__em-attachment-list {
    padding-left: 0px;
}
</style>
<style>
.__em-attachment-list .mint-cell-title {
    display: flex;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// emAttachmentList.vue?167b6ff0